module.exports = __webpack_public_path__ + "img/max_contact.b00e7f28.png";